import type { IconData } from '@stacksjs/iconify-core'

export const search: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M734 668q8 9 0 17l-49 49q-3 3-8 3t-8-3L519 584q-50 38-112 55t-133 6q-53-8-99-33t-83-61t-59-85T3 366q-10-79 16-150T96 95t121-76T367 3q53 7 100 30t84 59t62 82t33 100q11 69-6 131t-55 114zM325 557q48 0 90-18t74-50t50-74t18-90t-18-90t-50-74t-74-50t-90-18t-90 18t-73 50t-50 74t-18 90t18 90t50 74t73 50t90 18\"/>",
  "width": 740,
  "height": 840,
  "viewBox": "0 0 740 840"
}

export default search
